"use client";

import WhatsappSvg from "./svgIcons";

interface ContactButtonProps {
  phone: string;
  message?: string;
  position?: "left" | "right";
}

export default function ContactButton({
  phone,
  message = "Hola, necesito información",
  position = "left",
}: ContactButtonProps) {
  const cleanPhone = phone.replace(/\D/g, "");
  const url = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;

  const sideClass = position === "left" ? "left-6" : "right-6";

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      className={`fixed bottom-6 ${sideClass} group z-999 transition-transform duration-300 ease-out will-change-transform hover:scale-110 active:scale-95`}
    >
      <div className="relative flex justify-center items-center bg-[#25D366] hover:bg-[#20ba5a] shadow-2xl p-3.5 rounded-full overflow-visible">
        <span className="absolute inset-0 bg-[#25D366] opacity-40 blur-md rounded-full group-hover:scale-125 transition-transform duration-500" />

        <WhatsappSvg
          className="z-10 relative w-7 h-7 text-white transform-gpu"
          color="#fff"
        />
      </div>

      <span
        className={`absolute bottom-1/2 ${
          position === "left" ? "left-20" : "right-20"
        } pointer-events-none flex translate-y-1/2 flex-col items-center opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100 ${
          position === "left" ? "-translate-x-2" : "translate-x-2"
        }`}
      >
        <span className="bg-white shadow-lg px-4 py-2 border border-gray-100 rounded-xl font-bold text-[#20ba5a] text-sm whitespace-nowrap">
          Contáctanos
        </span>
      </span>
    </a>
  );
}
